import styled from "styled-components";

import colors from "../../assets/css/colors";

export const Button = styled.button`
  border: 0;
  outline: none;
  border-radius: 0;
  padding: 10px 12px;
  font-size: 1rem;
  width: 100%;
  font-weight: 600;
  border-radius: 12px;
  background: ${colors.primary};
  color: ${colors.white};
  transition: all .5s ease;

  -webkit-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
  -moz-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
  box-shadow: -4px 14px 50px -15px rgba(238, 168, 73, 1);

&:disabled {
  background: ${colors.grayDark};
  color: ${colors.grayLight};
  cursor: not-allowed;

  &:hover {
    background: ${colors.grayDark};
  }

  &:focus {
    background: ${colors.grayDark};
    outline:none !important;
  }

  -webkit-box-shadow: -4px 17px 50px -26px #d1d0ce;
  -moz-box-shadow: -4px 17px 50px -26px #d1d0ce;
  box-shadow: -4px 14px 50px -15px #d1d0ce;
}
  
&:hover {
  background: ${colors.quaternary};
}

&:focus {
  background: ${colors.quaternary};
  outline:none !important;
}

`;